import { render } from "./FooterMenu.vue?vue&type=template&id=4d681a41"
import script from "./FooterMenu.vue?vue&type=script&lang=js"
export * from "./FooterMenu.vue?vue&type=script&lang=js"

import "./FooterMenu.vue?vue&type=style&index=0&id=4d681a41&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__